import { get, post } from "./axiosClient"

type GetSurrenderRequest = {
    token: string
}

type GetSurrenderResponse = {
    message?: string,
    errorMessage?: string
}

export const callSurrender = async ({ token }: GetSurrenderRequest): Promise<GetSurrenderResponse> => {
    return await post({
        data: {},
        params: {
        },
        path: 'websystem/surrender',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { message: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}

export const getSurrender = async ({ token }: GetSurrenderRequest): Promise<GetSurrenderResponse> => {
    return await get({
        params: {
        },
        path: 'websystem/surrender',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { message: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}